export const ITERATING = Object.freeze({
    pageSize: 50,
});

export const ENTITIES = Object.freeze({
    skip: 0,
    take: 25,
});

export const FILE_UPLOAD = Object.freeze({
    chunkSize: 1000000,
});
